import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const decodeUnicode = (str) => {
    return str.replace(/\\u[\dA-F]{4}/gi, (match) => {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
};

const formattedErrorMessage = (error) => {
    if (error.response && error.response.status === 422 && error.response.data) {
        // Laravel validation errors format
        if (error.response.data.errors && typeof error.response.data.errors === 'object') {
            return Object.values(error.response.data.errors)
                .flat()
                .map(decodeUnicode)
                .join('\n');
        }
        // Legacy format with 'error' field
        else if (error.response.data.error && typeof error.response.data.error !== 'string') {
            return Object.values(error.response.data.error)
                .flat()
                .map(decodeUnicode)
                .join('\n');
        } else {
            return decodeUnicode(error.response.data.error || error.response.data.message || 'Request failed with status code 422');
        }
    } else if (error.error && typeof error.error !== 'string') {
        return Object.values(error.error)
            .flat()
            .map(decodeUnicode)
            .join('\n');
    } else {
        return decodeUnicode(error.error || error.message || 'An unknown error occurred');
    }
};

// const formattedErrorMessage = error => {
//     if (error.error && typeof error.error !== 'string') {
//         return Object.values(error.error).flat().join('\n')
//     } else {
//         return error.error || error.message
//     }
// }

// Сетевые ошибки (нет ответа сервера) после сна компьютера, смены сети или в фоновой вкладке
// дают фоновые опросы по setInterval — пользователю показывать их не нужно
const NETWORK_ERROR_GRACE_MS = 10 * 1000;
const USER_IDLE_MS = 30 * 1000;
let networkResumedAt = Date.now();
let lastNetworkToastAt = 0;
let lastUserActivityAt = Date.now();

const markUserActivity = () => {
    lastUserActivityAt = Date.now();
};
['mousedown', 'keydown', 'touchstart'].forEach(eventName => {
    window.addEventListener(eventName, markUserActivity, { capture: true, passive: true });
});

const markNetworkResumed = () => {
    networkResumedAt = Date.now();
};
window.addEventListener('online', markNetworkResumed);
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        markNetworkResumed();
    }
});

const shouldShowNetworkErrorToast = () => {
    const now = Date.now();
    if (document.hidden || !navigator.onLine) {
        return false;
    }
    // Пользователь бездействует — запрос фоновый, не беспокоим
    if (now - lastUserActivityAt > USER_IDLE_MS) {
        return false;
    }
    if (now - networkResumedAt < NETWORK_ERROR_GRACE_MS) {
        return false;
    }
    if (now - lastNetworkToastAt < NETWORK_ERROR_GRACE_MS) {
        return false;
    }
    lastNetworkToastAt = now;
    return true;
};

// Отлов ошибок при запросах
axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;

        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        if (error && !error.response) {
            console.warn('Network error:', originalRequest && originalRequest.url, error.message);
            if (!shouldShowNetworkErrorToast()) {
                return Promise.reject(error);
            }
        }

        if (error && error.response && error.response.status === 401) {
            // Don't logout for push notification requests
            const isPushRequest = originalRequest.url && (
                originalRequest.url.includes('/api/push') || 
                originalRequest.url.includes('/api/notify')
            );
            
            if (!isPushRequest) {
                store.dispatch('auth/AUTH_LOGOUT')
                let errorMessage = 'Ваша сессия истекла. Войдите снова, чтобы продолжить работу.';
                
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }

                Vue.$toast.error(errorMessage, {
                    position: 'top-right',
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 1,
                    showCloseButtonOnHover: true,
                    hideProgressBar: true,
                    closeButton: 'button',
                    icon: 'fa fa-exclamation-triangle',
                    rtl: false,
                });

                if (window.location.pathname !== '/login') {
                    router.push('/login');
                }
            } else {
                // For push requests, just log the error silently and return success
                console.warn('Push notification request failed:', error.response?.data?.message || 'Authentication failed');
                // Return a resolved promise to prevent the error from propagating
                return Promise.resolve({ data: { success: false, message: 'Push request failed' } });
            }
        } else if (error && error.response && error.response.status === 500 && !originalRequest._retry) {
            originalRequest._retry = true;
            return axios(originalRequest);
        } else {
            Vue.$toast.error(formattedErrorMessage(error), {
                position: 'top-right',
                closeOnClick: true,
                timeout: 5000,
                pauseOnFocusLoss: false,
                pauseOnHover: false,
                draggable: true,
                draggablePercent: 1,
                showCloseButtonOnHover: true,
                hideProgressBar: true,
                closeButton: 'button',
                icon: 'fa fa-exclamation-triangle',
                rtl: false,
            });
        }
        return Promise.reject(error)
    }
)
